// extracted by mini-css-extract-plugin
export default {"actions":"actions-4v9t4","footer":"footer-wIRan"};